export const PERSON_ROLES = {
  CLIENT: 'CLIENT',
  EMPLOYEE: 'EMPLOYEE',
} as const;

/**
 * Вид диалога (`conversationType`): `TRANSCRIBATION` — звонок с записью и расшифровкой,
 * `TEXT` — текстовая коммуникация, которая показывается перепиской.
 */
export const CONVERSATION_TYPES = {
  TEXT: 'TEXT',
  TRANSCRIBATION: 'TRANSCRIBATION',
} as const;

/**
 * Вид элемента переписки текстовой коммуникации (`type` элемента ленты): сообщение, внутренняя
 * заметка, событие сработавшего правила и виджет.
 */
export const MESSAGE_TYPES = {
  MESSAGE: 'MESSAGE',
  NOTE: 'NOTE',
  RULE: 'RULE',
  WIDGET: 'WIDGET',
} as const;

/** Отправитель элемента переписки текстовой коммуникации (`senderType` элемента ленты) */
export const SENDER_TYPES = {
  CLIENT: 'CLIENT',
  EMPLOYEE: 'EMPLOYEE',
  SYSTEM: 'SYSTEM',
  BOT: 'BOT',
} as const;

/** Форматы аудиофайла записи, которые принимает загрузка `POST /conversation/audiofile` */
export const CONVERSATION_AUDIO_FILE_TYPES = ['.mp3', '.wav', '.m4a', '.aac', '.flac'];

/** Наибольший размер аудиофайла записи в мегабайтах, который принимает загрузка `POST /conversation/audiofile` */
export const CONVERSATION_AUDIO_MAX_SIZE_MB = 100;

/**
 * Phrase type enum per OpenAPI PhraseTypeEnum
 *
 * Типы событий в диалоге, которые могут приходить в ответе GET /conversation/{id}/transcript:
 *
 * - `PHRASE` - фраза диалога (основной тип события)
 *   Обязательные поля: `person`, `finishedAt`
 *   Опциональные поля: `text`, `angry`, `sad`, `neutral`, `positive` (если прошла обработка LLM на определение эмоций)
 *
 * - `INTERRUPTION` - сведения о прерывании в диалоге (когда один участник прерывает другого)
 *   Обязательные поля: `finishedAt`, `interruptedPhraseId`, `interruptionPhraseId`
 *
 * - `PAUSE` - сведения о паузах в диалоге
 *   Обязательные поля: `finishedAt`; `personId` есть у пауз, найденных речевой аналитикой, и пуст у добавленных вручную
 *
 * - `STOP_WORD` - сведения о стоп-словах, которые встретились в диалоге
 *   Обязательные поля: `stopWordId`, `person`, `stopWordPhraseId`
 */
export const PHRASE_TYPES = {
  /** Фраза диалога - основной тип события, содержащий текст и информацию о говорящем */
  PHRASE: 'PHRASE',
  /** Прерывание в диалоге - когда один участник прерывает речь другого */
  INTERRUPTION: 'INTERRUPTION',
  /** Пауза в диалоге - пауза в речи участника */
  PAUSE: 'PAUSE',
  /** Стоп-слово - обнаруженное стоп-слово в тексте фразы */
  STOP_WORD: 'STOP_WORD',
} as const;

/**
 * Типы записей расшифровки, которые правятся в режиме редактирования карточки диалога:
 * их показывает лента режима, из них выбирается вид новой записи, и только их принимают
 * эндпоинты правки `/conversation/{conversationId}/phrase`. Записи прочих типов не правятся.
 */
export const EDITABLE_PHRASE_TYPES = [PHRASE_TYPES.PHRASE, PHRASE_TYPES.INTERRUPTION, PHRASE_TYPES.PAUSE] as const;
